export const addCommas = number => {
    if (number.toString().includes(".")) {
        let parts = number.toString().split(".");

        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts[0] + "," + parts[1].substring(0, 2);
    } else {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
};